module.exports = __webpack_public_path__ + "img/spotify.bc39765c.png";